import { render, staticRenderFns } from "./StudySetCreateFooter.vue?vue&type=template&id=34bf9569&scoped=true&"
import script from "./StudySetCreateFooter.vue?vue&type=script&lang=js&"
export * from "./StudySetCreateFooter.vue?vue&type=script&lang=js&"
import style0 from "./StudySetCreateFooter.vue?vue&type=style&index=0&id=34bf9569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf9569",
  null
  
)

export default component.exports